/**
 * `<input type="datetime-local">` の値とサーバーへ送る時刻の相互変換。
 *
 * 入力欄の値はタイムゾーンを持たない（例: `2026-09-18T10:00`）。
 * そのまま送るとサーバー（UTC のコンテナ）でその時刻として解釈され、日本時間と9時間ずれる。
 * 送信前にブラウザのローカル時刻として解釈し、オフセットを含む ISO 文字列に変換する。
 */

/** 入力欄の値 → サーバーへ送る ISO 文字列。空や不正な値は undefined */
export function fromDatetimeLocal(value: string | undefined | null): string | undefined {
  if (!value) return undefined

  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return undefined

  return date.toISOString()
}

/** サーバーから受け取った時刻 → 入力欄に表示する値。空や不正な値は空文字 */
export function toDatetimeLocal(value: string | Date | undefined | null): string {
  if (!value) return ''

  const date = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(date.getTime())) return ''

  const pad = (n: number) => String(n).padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`
}
